/**
 * Early-bird launch pricing deadline: 15 August 2026, 9am UK time. Single
 * source of truth for the countdown banner (apps/web/lib/earlyBird) and the
 * usage-nudge upsell email. The Convex backend can't import this package into
 * its bundle, so it mirrors EARLY_BIRD_DEADLINE_ISO in
 * packages/backend/convex/utils/board.ts — keep the two in sync.
 */
export const EARLY_BIRD_DEADLINE_ISO = "2026-08-15T09:00:00+01:00";

export const EARLY_BIRD_DEADLINE = new Date(EARLY_BIRD_DEADLINE_ISO);
